window.Language = function () {
    var el = this;

    const RU = 1;

    el.current = RU;

    el.render = function () {
        $('.js-set-language').val(el.current)
    };

    el.set = function (value) {
        el.current = value;
        el._parent.workData.language = value;
        el.render();
    };

    el.init = function () {
        if (el.project.current.constructor.hasOwnProperty('language')) {
            el.set(el.project.current.constructor.language);
        }
        else {
            el.set(window.currentLanguageId)
        }
    };

    $(document).on('change', '.js-set-language', function () {
        el.set($(this).val());

        el.calendarGrid.init();
        el.calendarGrid.updateDate();
        el.workarea.render();
        el.preview.render();
    });
};